const FAQ_NODE_TYPES = {
    CATEGORY: 'cat',
    ARTICLE: 'art',
}

const FAQ_BASE_PATH = '/faq';

export {
    FAQ_NODE_TYPES,
    FAQ_BASE_PATH,
}